import React, { useEffect, useReducer, useState } from 'react';
import { Empty, Row, Col, Select, Typography, Button, Space, Table, Form, Input, Modal, Tooltip, message, Popover, Avatar, Card, Tag, Tabs, Spin} from 'antd';
import { Content } from 'antd/es/layout/layout';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../Context';
import { ASSET_REPORT_LIST, ASSET_REPORT_LIST_SUCCESS, ASSET_REPORT_LIST_ERROR, ASSET_REPORT_DETAILS, ASSET_REPORT_DETAILS_ERROR, ASSET_REPORT_DETAILS_SUCCESS, ADD_ASSET_REPORT, ADD_ASSET_REPORT_SUCCESS, ADD_ASSET_REPORT_ERROR,  ASSET_REPORT_UPDATE, ASSET_REPORT_UPDATE_SUCCESS, ASSET_REPORT_UPDATE_ERROR, DELETE_ASSETS, DELETE_ASSETS_SUCCESS, DELETE_ASSETS_ERROR, ASSET_TYPE_LIST, ASSET_TYPE_LIST_SUCCESS, ASSET_TYPE_LIST_ERROR} from './constants';
import axios from 'axios';

import { useFormik } from 'formik';

import { DownloadOutlined, ScheduleOutlined , InfoOutlined, SnippetsOutlined ,EditOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';

import englan from '../../english.json';
import germanlan from '../../german.json';
import arabiclan from '../../arabic.json';
import frenchlan from '../../french.json';
import hindilan from '../../hindi.json';
import malayalamlan from '../../malayalam.json';

import chaingeFilterReducer from './reducer';
import TabPane from 'antd/es/tabs/TabPane';
import { Option } from 'antd/es/mentions';
import { BatchDownloader } from './assetdownloader';

const { Title } = Typography;

let asset_data_pagination = {};

let urls=[];


export default function AssetReport() {
	
	const [openEditDrawer, setOpenEditDrawer] = useState(false);
	const [openAddDrawer, setOpenAddDrawer] = useState(false);
	
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const navigate = useNavigate();
	const {getRegion, regiondata, getUserAllocation ,getUserAllocationData , handleGetMapdata, mapdata} = useAuth();
	const initalState = {assets:[],assetType:[], details: null, loading: false, error: false , pagination: { total: 0, limit: 10, skip: 0, current:1 },filterChainage : [] };
	const [asset, dispatch] = useReducer(chaingeFilterReducer, initalState);
	const [modalRegionId , setModalRegion] = useState(null);
	const [showDeleteAssetsModal, setShowDeleteAssetsModal] = useState(false);
	
	
	const [form] = Form.useForm();	

	const [regionId, setRegionId] = useState(null);
	const [assetTypeId, setAssetTypeId] = useState(null);

	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const admin_roles = ['superadmin','admin','Station-In-Charge','Pipeline-HO','Pipeline-In-Charge','HQO-HSE'];
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const [allocationId, setAllocationId] = useState(null);

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const [openAttachmentModal, setShowAttachmentsModal] = useState(false);
	const [showFetchAndDownloadModal, setShowFetchAndDownloadModal] = useState(false);
	
	const [images , setImages] = useState([]);
	const [url, setURL] = useState(null);

	function imageHandler(val,options){

		if(options==='add'){
			const newImages = [...images, val];
			setImages(newImages);
			addAsset.setFieldValue('attachmentUrls',newImages);
		}else if(options==='edit'){

			const newImages = [...images, val];
			setImages(newImages);
			formik.setFieldValue('attachmentUrls',newImages);

			
		}
			
	} 
	
	
		
	function editImageHandler(record){
		setImages(record);
	}

	let image_attachements = [];
	const pipelineChainages = [{value : null, label : 'N/A'}];
	// eslint-disable-next-line array-callback-return
	mapdata && mapdata.map((item) => {
		pipelineChainages.push({
			value : item.id,
			label : `${item.pipelineChainage} ( ${item.rouMarker} )`
		});
	});

	asset.details?.attachmentUrls.map((item)=>{

		const lower = item.toLowerCase().trim();

		if (lower.endsWith('.jpeg') || lower.endsWith('.jpg') || lower.endsWith('.png') || lower.endsWith('.svg') || lower.endsWith(' ')) {
			urls.push(item);
			image_attachements.push(item);
		}else{
			image_attachements.push(item);
		} 
	});
	const openDeleteAssetsModal = () => {
		// setShowDeleteGeofenceManagementModal(true);
		setShowDeleteAssetsModal(true);
	};
	
	const closeDeleteAssetsModal = () => {
		setShowDeleteAssetsModal(false);
	};
	
	const deleteAssets = () => {
		const id = parseInt(asset.details.id);
		
		dispatch({ type: DELETE_ASSETS });
	
		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/assets/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
	
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_ASSETS_SUCCESS, payload: response});
					setShowDeleteAssetsModal(false);   
					getAsset(1);       
				} else {
					dispatch({type:DELETE_ASSETS_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_ASSETS_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	

	const columns = [
		{
			title: `${langdata&&langdata.AssetName?langdata.AssetName:'Asset Name'}`,
			dataIndex: 'name',
			key: 'name',
			

			render: (_,record) => (
				<a onClick={() => {navigate(( '/maintenance-history'),{ state: { assetId:record.id } });}}>
					{record.name}
				</a>
			)

		},
		{
			title: `${langdata&&langdata.Region?langdata.Region:'Region'}`,
			dataIndex: 'regionInfo',
			key: 'regionInfo',
		},
		{
			title: `${langdata&&langdata.Chainage?langdata.Chainage:'Chainage'} (m)`,
			dataIndex: 'pipelineChainage',
			key: 'pipelineChainage',
			render:(_,record)=>{
				return record.pipelineChainage ? record.pipelineChainage : 'No Data';
			}
		},
		
		{
			title: `${langdata&&langdata.Status?langdata.Status:'Status'}`,
			dataIndex: 'status',
			key: 'status',

			render: (_, { status }) => (
				<>
					<Tag
						color={
							status === 'In Use'
								? 'green'
								: status === 'Maintenance'
									? 'yellow'
									: status === 'Damaged'
										? 'red'
										: 'default'
						}
					>
						{status}
					</Tag>
				</>
			),
		},
		{
			title: `${langdata&&langdata.Remark?langdata.Remark:'Remark'}`,
			dataIndex: 'remarks',
			key: 'remarks',
			render:(_,record)=>{
				return record.remarks ? record.remarks : 'No Data';
			}
		},
		{
			title : `${langdata&&langdata.AssetType?langdata.AssetType:'Asset Type'}`,
			dataIndex : 'assettypeName',
			key : 'assettypeName',
			render:(_,record)=>{
				return record.assettypeName ? record.assettypeName : 'No Data';
			}

		},
		
		
      
		{
			title: `${langdata && langdata.Actions ? langdata.Actions:'Actions'}`,
			key: 'attachmentUrls',
			align:'center',
			render: (_,record) => (
				

				<>
					<Space style={{justifyContent:'center',display:'flex'}} size="middle">
						<a title={langdata && langdata.SHOWATTACHMENTS ? langdata.SHOWATTACHMENTS:'SHOW ATTACHMENTS'} disabled={record.attachmentUrls.length <=0} onClick={record.attachmentUrls.length > 0 ? openShowAttachments : null}><SnippetsOutlined/></a>
						<a title={langdata && langdata.Edit ? langdata.Edit:'Edit'}  onClick={showEditDrawer}><EditOutlined/></a>
						<a title={langdata && langdata.Delete ? langdata.Delete :'Delete'} onClick={openDeleteAssetsModal}><DeleteOutlined /></a>

					</Space>
				</>
			)
		}
	];
	
	let regions=[{
		value : null , label : langdata.All ? langdata.All : 'All'
	}];

	let modalRegion = [];

	if(admin_roles.includes(permission)){ 	
		regiondata && regiondata.map((region)=>{
			regions.push({
				value:region.id,
				label:region.regionName.toUpperCase()});
		}) ,
		regiondata && regiondata.map((region)=>{
			modalRegion.push({
				value:region.id,
				label:region.regionName.toUpperCase()});
		}) 
		;
	} else {
		getUserAllocationData && getUserAllocationData.map((region)=>{
			regions.push({
				value:region.id,
				label: region.regioninfo.regionName+'(' + region.pipelineConfigFrom+' - '+region.pipelineConfigTo + ')',
				region: region.regioninfoId,
				pipelineConfigFrom : region.pipelineConfigFrom,
				pipelineConfigTo : region.pipelineConfigTo
			}) ,
			modalRegion.push({
				value:region.id,
				label: region.regioninfo.regionName+'(' + region.pipelineConfigFrom+' - '+region.pipelineConfigTo + ')',
				region: region.regioninfoId,
				pipelineConfigFrom : region.pipelineConfigFrom,
				pipelineConfigTo : region.pipelineConfigTo
			});
			
		});
	}

	const handleStartChainage = (value,type) => {
		
		// eslint-disable-next-line array-callback-return
		if(type === 'add'){ addAsset.setFieldValue('pipelineChainageId', value);}
		
		if(type === 'edit'){formik.setFieldValue('pipelineChainageId', value);}
		
	};

	
	useEffect(()=>{
		if(!authtoken){
			navigate('/');
		}
		else{
			if(admin_roles.includes(permission)){
				getRegion(authtoken);
			}
			else{
				getUserAllocation(authtoken);
			}
			dispatch({type:ASSET_REPORT_LIST});
			handleGetMapdata(authtoken,modalRegionId,null,null).then(()=>{
				loadAssetType();
				getAsset(1);

			}
			);
			
			// loadAssetType();
			// getAsset(1);
		}

	},[authtoken,regionId, allocationId,modalRegionId, assetTypeId]);

	useEffect(() => {
		if(featuresModule.assetsEnabled == false) {
			navigate('/dashboard');
		}
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 4011);
		
	}, []);


	const getAsset =(pagination)=>{

		let _pagination = { };
		_pagination.total = asset_data_pagination.total ? asset_data_pagination.total : 0;
		_pagination.limit = pagination.pageSize ? pagination.pageSize : 10;
		_pagination.skip =  pagination && pagination.current ? parseInt((pagination.current-1) * pagination.pageSize) : 0;

		localStorage.setItem(`${dashboardtype.toUpperCase()}_PAGE`, pagination && pagination.current ? pagination.current : 1);
		localStorage.setItem(`${dashboardtype.toUpperCase()}_PAGE_SIZE`, pagination && pagination.pageSize ? pagination.pageSize : 10);

		
		let params = '';
		if(regionId){
			params += `&regioninfoId=${regionId}`;
		}
		if(assetTypeId){
			params+=`&assettypeId=${assetTypeId}`;
		}
		dispatch({ type :ASSET_REPORT_LIST});
		setURL({base: `${api}/assets`,params:`pipelineId=${parseInt(pipelineId)}${params}`});
		
		// setURL({base: `${api}/shiftreport-list`,params:`date=${date.split('/').reverse().join('-')}${allocationParams}`});
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url:`${api}/assets?pipelineId=${parseInt(pipelineId)}${params}&$sort[id]=-1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : ''
		};
      
		axios.request(config)
			.then((response) => {

				if (response.status === 200) {
					asset_data_pagination.total = response.data.total ? response.data.total : 0;
					asset_data_pagination.limit = response.data.limit ? response.data.limit : 10;
					asset_data_pagination.skip = response.data.skip ? response.data.skip : 0;
					asset_data_pagination.current = pagination.current ? pagination.current : 1;
					dispatch({ type : ASSET_REPORT_LIST_SUCCESS, payload : response.data.data , page:pagination.current, pageSize : pagination.pageSize});
				
				}else {
					dispatch({ type : ASSET_REPORT_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : ASSET_REPORT_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});

	};


	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  asset?.details?.name || '',
			remarks: asset?.details?.remarks || '',
			status: asset?.details?.status || 'In Use',
			pipelineChainageId : asset?.details?.pipelineChainageId ? asset.details.pipelineChainageId : null,
			attachmentUrls: asset?.details?.attachmentUrls ? asset.details.attachmentUrls : [],
			regioninfoId : asset?.details?.regioninfoId ? asset.details.regioninfoId : 1,
			assettypeId : asset?.details?.assettypeId ? asset?.details?.assettypeId : null
		},
		onSubmit: (values) => {

	
			dispatch({type:ASSET_REPORT_UPDATE});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/assets/${asset.details.id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					name : values.name,
					remarks : values.remarks,
					status: values.status,
					pipelineChainageId : parseInt(values.pipelineChainageId),
					attachmentUrls: values.attachmentUrls,
					regioninfoId : values.regioninfoId,
					assettypeId : values.assettypeId
				}
			};
  
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200) {
						dispatch( { type: ASSET_REPORT_UPDATE_SUCCESS, payload: response.data.data });
						Modal.success({ title: `${langdata && langdata.AssetUpdatedSuccessfully ? langdata.AssetUpdatedSuccessfully :'Asset updated successfully'}` });
						formik.resetForm();
						form.resetFields();
						setOpenEditDrawer(false);
						setImages([]);
						getAsset({current : parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_PAGE`)), skip : (parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_PAGE`)) - 1) * 10, pageSize : parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_PAGE_SIZE`))});
						
					}
				})
				.catch((error) => {
					console.log(error);
					
					dispatch({ type: ASSET_REPORT_UPDATE_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});

		}
          
	});


	const showEditDrawer = () => {
		setOpenEditDrawer(true);
		
	};

	const showAddDrawer = () => {
		setImages([]);
		setOpenAddDrawer(true);
		
	};

	const onCloseAddDrawer = () => {
		setOpenAddDrawer(false);
		setImages([]);
		form.resetFields();
	};

	const handleModalCancel = () => {
		setOpenEditDrawer(false);
		setImages([]);
	};


	const handleSetregion = (e, options) =>{
		localStorage.setItem(`${dashboardtype}_REGION_ID`,e);
		if(admin_roles.includes(permission)) {
			setRegionId(e);
		} else {
			setRegionId(options.region);
			setAllocationId(e);
		}
		
	};

	const handleSetAssetType = (e,options) =>{
		setAssetTypeId(options.value);
	};



	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	const closeShowAttachments = () => {
		setShowAttachmentsModal(false);
		setImages([]);
		
	};

	const openShowAttachments = () => {
		
		setShowAttachmentsModal(true);

	};

	const loadassetlistdetails = ((record) => {
		dispatch( { type: ASSET_REPORT_DETAILS });
		
		if (!record) {
			dispatch({ type: ASSET_REPORT_DETAILS_ERROR });
		} else {
			dispatch({ type: ASSET_REPORT_DETAILS_SUCCESS, payload: record });
	
		}
	
	});

	const handleDownload = (imageUrl) => {
		fetch(imageUrl)
			.then(response => response.blob())
			.then(blob => {
			// Extract filename from URL
				const filename = imageUrl.substring(imageUrl.lastIndexOf('/') + 1);
				const url = window.URL.createObjectURL(new Blob([blob]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', filename);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
			.catch(error => console.error('Error downloading image:', error));
	};
	

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{langdata && langdata.assetReportInfoContent ? langdata.assetReportInfoContent :'This module is used to manage system assets, track their condition, and maintain detailed maintenance reports.'}</p>
			<br />
			{/* <p>{langdata && langdata.gradecontent2 ? langdata.gradecontent2 :'To achieve a green grade, the following criteria must be met: patch coverage greater than 90%, average speed less than 6.5 km/h, idle time under 45 minutes, and fewer than three violations. These criteria can be configured in the grade management section.'}</p>
			< br/>
			<p>{langdata && langdata.gradecontent3 ? langdata.gradecontent3 :'By default, the report displays details for one day, with filter options available for allocation and date.'}</p> */}
		</Card>
	);



	
	const addAsset = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  '',
			remarks: '',
			status: 'In Use',
			pipelineChainageId : null,
			regioninfoId : null,
			assettypeId : null

		},
		onSubmit: (values) => {

			
			
			
			if (!values.name || values.name == null || values.name === '') {
				Modal.warning({ title: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name.' });
				return false;
			}
			if (!values.remarks || values.remarks == null || values.remarks === '') {
				Modal.warning({ title: langdata && langdata.Pleaseenteryourremarks ? langdata.Pleaseenteryourremarks : 'Please Enter Your Remarks' });
				return false;
			}
			// if (!values.pipelineChainageId || values.pipelineChainageId == null || values.pipelineChainageId === '' || values.pipelineChainageId === 0 ) {
			// 	Modal.warning({ title: langdata && langdata.PleaseEnterTheChainage ? langdata.PleaseEnterTheChainage : 'Please enter the chainage' });
			// 	return false;
			// }

			dispatch({type:ADD_ASSET_REPORT});
			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/assets?pipelineId=${pipelineId}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					name : values.name,
					remarks : values.remarks,
					status: values.status,
					pipelineChainageId : parseInt(values.pipelineChainageId),
					pipelineId : parseInt(pipelineId),
					regioninfoId : values.regioninfoId,
					attachmentUrls : values.attachmentUrls ,
					assettypeId : values.assettypeId
				}
			};
  
			axios
				.request(config)	
				.then((response) => {
					

					if (response.status === 200 || response.status === 201) {

	
						dispatch( { type: ADD_ASSET_REPORT_SUCCESS, payload: response.data.data });

						Modal.success({ title: `${langdata && langdata.AddAssetSuccessfully ? langdata.AddAssetSuccessfully :'Add Asset Successfully'}` });
						getAsset(1);
						form.resetFields();
						addAsset.resetForm();
						setImages([]);
						setOpenAddDrawer(false);

					
					}
				})
				.catch((error) => {
					console.log(error);
					
					dispatch({ type: ADD_ASSET_REPORT_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});

		}
	});
	
	
	

	const onChangeImage = (event,options) => {
		const file = event.target.files[0];
		const formData = new FormData();
		formData.append('file',file && file ? file : '');
		
	
		let config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: `${api}/fileattachment`,
			timeout: timeout,
			headers: { 
				// 'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : formData
		};
		
		axios.request(config)
			.then((response) => {
				if (response.status === 201) {
					imageHandler(response.data.fileUrl,options);
					Modal.success({ title: `${langdata && langdata.Fileuploadedsuccessfully ? langdata.Fileuploadedsuccessfully :'File uploaded successfully'}` });
					// dispatch({ type : ACKNOWLEGEMENT_ALARM_FILE_UPLOAD_SUCCESS, payload : response.data});
					// data = response.data
				}else {
					// dispatch({ type : ACKNOWLEGEMENT_ALARM_FILE_UPLOAD_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
				// dispatch({ type : ACKNOWLEGEMENT_ALARM_FILE_UPLOAD_ERROR});
			});
	

	};

	

	


	const handleRegion = (value) => {
		setModalRegion(value);
		
		
	};
		

	
	const handleAddFormValuesChange = (changedValues)=>{
		
		const regionVal = Object.keys(changedValues)[0];

		if(regionVal==='regioninfoId'){
			addAsset.setFieldValue('regioninfoId', changedValues.regioninfoId);
			addAsset.setFieldValue('pipelineChainageId', undefined);

		}
		else if(regionVal == 'assettypeId'){
			addAsset.setFieldValue('assettypeId',changedValues.assettypeId);
		}
		
	};
		
	const handleUpdateFormValuesChange = (changedValues)=>{
		
		const regionVal = Object.keys(changedValues)[0];
		
		
		if(regionVal==='regioninfoId'){
			
			
			formik.setFieldValue('regioninfoId', changedValues.regioninfoId);
			formik.setFieldValue('pipelineChainageId', undefined);

		}
		if(regionVal == 'assettypeId'){
			formik.setFieldValue('assettypeId', changedValues.assettypeId);
		}
	};

	const loadAssetType = () => {
		dispatch({ type :ASSET_TYPE_LIST}); 
		
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url:`${api}/assettype?pipelineId=${parseInt(pipelineId)}&$sort[id]=-1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : ''
		};
      
		axios.request(config)
			.then((response) => {
				// console.log('asset type list response' , response.data.data);

				if (response.status === 200) {
					
					dispatch({ type : ASSET_TYPE_LIST_SUCCESS, payload : response.data.data});
				
				}else {
					dispatch({ type : ASSET_TYPE_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : ASSET_REPORT_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});
	};
	
	// const assetTypeOptions = Object.values(asset.assetType).map(item => item.name);
	const assetTypeOptions = [{value : null, label : langdata.All ? langdata.All : 'All'}];
	const modalAssetTypeOptions = [];

	if(asset.assetType){ 	
		asset.assetType.map((item)=>{
			assetTypeOptions.push({
				value:item.id,
				label:item.name.toUpperCase()});
		});
		asset.assetType.map((item)=>{
			modalAssetTypeOptions.push({
				value:item.id,
				label:item.name.toUpperCase()});
		});
	}

	const openShowFetchAndDownloadModal = () => {
		setShowFetchAndDownloadModal(true);
	};

	const closeShowFetchAndDownloadModal = () => {
		setShowFetchAndDownloadModal(false);
	};

	
	

	return (
		<>
			<Content>
				<Row
					style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center',
					}}
				>


					<Col span={10}>
						<Row>

							<Space>
								<ScheduleOutlined style={{fontSize:'30px'}}/>
							</Space>

							<Space>&nbsp;&nbsp;</Space>
					
					
							<Title level={4} style={{ paddingTop:'10px'}}>{langdata&&langdata.Assets?langdata.Assets:'Assets'}</Title>
						</Row>
					</Col>
					<Col style ={{display:'flex',justifyContent:'flex-end'}} span={14} >
						<Row style ={{display:'flex',justifyContent:'flex-end',}}>
							<Col span={24} style={{display:'flex',flexWrap:'wrap',justifyContent:'flex-end', gap:'8px',maxWidth:'920px',paddingRight:'10px'}}>

								<Tooltip placement="bottom" title={langdata && langdata.FilterByAssetType ? langdata.FilterByAssetType:'Filter by asset type'}>
									<Space>
										<Select Item
											showSearch
											filterOption={filterOption}
											style={{ minWidth: '200px', margin:'5px'}}
											placeholder={langdata && langdata.SelectAssetType ? langdata.SelectAssetType:'Select Asset Type'}
											optionFilterProp="children"
											defaultValue={null}
											options={assetTypeOptions}
											onSelect={(e, options)=>handleSetAssetType(e, options)}
										/>
									</Space>
								</Tooltip>
								{/* <Space>&nbsp;&nbsp;</Space> */}
								<Tooltip placement="bottom" title={langdata && langdata.Filterbyregion ? langdata.Filterbyregion:'Filter by region'}>
									<Space>
										<Select Item
											showSearch
											filterOption={filterOption}
											style={{ minWidth: '200px', margin:'5px'}}
											placeholder={langdata && langdata.SelectRegion ? langdata.SelectRegion:'Select Region'}
											optionFilterProp="children"
											defaultValue={null}
											options={regions}
											onSelect={(e, options)=>handleSetregion(e, options)}
										/>
									</Space>
								</Tooltip>
								{/* <Space>&nbsp;&nbsp;</Space> */}

								
								<Tooltip placement="bottom" title={langdata && langdata.Add ? langdata.Add : 'Add'}>
									<Space>
										
										{ permission === 'superadmin' || permission === 'admin' ? <Button onClick={showAddDrawer} type='primary' style={{margin:'5px'}}  ><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New' }</Button> : null }
									</Space>
								</Tooltip>
								{/* <Space>&nbsp;&nbsp;</Space> */}
								<Space>
									<Typography>
										<Popover title={langdata && langdata.Assets ? langdata.Assets : 'Assets'}  content={infoContent} trigger="click">
											<Avatar size="small" style={{marginTop:'5px',marginBottom:'5px'}}><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
					{/* </Space> */}
				</Row>

				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						{asset && asset.assets && asset.assets.length > 0 ? (
							<Table 
								scroll={{
									x: 900,
								}}
								columns={columns} dataSource={asset.assets} pagination = { asset.assets.length > 0 ? asset.pagination : 0 }  onChange = { getAsset } 
								onRow = {(record) => {
									return {
										onClick: () => { 
											loadassetlistdetails(record);
											editImageHandler(record.attachmentUrls);
												
										}
									};
								}}/>
						)
							:
							(
								<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
							)}
					</Col>
				</Row>

				<Row gutter={{
					xs: 8,
					sm: 16,
					md: 24,
					lg: 32,
				}}
				style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center',
					justifyContent:'center',
					display:'flex'
				}} 
				>
					

				</Row>

				<Row gutter={{
					xs: 8,
					sm: 16,
					md: 24,
					lg: 32,
				}}
				style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center',
					justifyContent:'center',
					display:'flex'
				}} 
				>
					<Col style={{
						alignItems:'left',
						justifyContent:'left',
						display:'flex',
						padding:'10px'
					}}  className="gutter-row" span={24}>
						<Button disabled={asset.assets && asset.assets.length > 0 ? false : true} type="primary" title={langdata && langdata.DownloadReport ? langdata.DownloadReport:'Download Report'} onClick={openShowFetchAndDownloadModal}><DownloadOutlined />{langdata && langdata.Download ? langdata.Download:'Download'}</Button>
					</Col>
				
				</Row>

				<Spin fullscreen spinning={asset.loading} />
			</Content>
            
			{/* Add Asset modal starts				 */}
			<Modal
				title={ langdata&&langdata.AddAsset ? langdata.AddAsset : 'Add Asset' }
				centered
				destroyOnClose={true}
				maskClosable={false}
				open={openAddDrawer}
				onOk={{onCloseAddDrawer}}
				onCancel={onCloseAddDrawer}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={onCloseAddDrawer}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
						{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={addAsset.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
					</Space>
				]}
				width={800}
			>
				<Form layout="vertical" onSubmit={addAsset.handleSubmit} form={form} onValuesChange={handleAddFormValuesChange}>
					
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="name" label={langdata&&langdata.Name?langdata.Name:'Name'} rules={[{ required: true, message: langdata && langdata.PleaseEnterName ? langdata.PleaseEnterName : 'Please Enter Name' }]} >
								<Input name="name" onChange={addAsset.handleChange} placeholder={langdata&&langdata.PleaseEnterName?langdata.PleaseEnterName:'Please Enter Name'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="remarks" label={ langdata&&langdata.Remarks?langdata.Remarks:'Remarks'} rules={[{ required: true, message: langdata && langdata.PleaseEnterRemark ? langdata.PleaseEnterRemark : 'Please Enter Remark' }]} >
								<Input name="remarks" onChange={addAsset.handleChange} placeholder={langdata&&langdata.PleaseEnterRemark?langdata.PleaseEnterRemark:'Please enter the remark'} />
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item
								label={langdata?.AssetType || 'Asset Type'}
								name="assetType"
								rules={[{ required: false, message: 'Please select asset type.' }]}
							>
								<Select
									name="assetType"
									style={{ minWidth: '100%'}}
									
									filterOption={filterOption}
									placeholder={langdata && langdata.AssetType ? langdata.AssetType : 'Asset Type'}
									optionFilterProp="children"
									options={modalAssetTypeOptions}
									// onChange={handleRegion}
									
									onSelect={(value)=>{handleAddFormValuesChange({'assettypeId': value});}}
								/>
							

							</Form.Item>
			
						</Col>
					</Row> 
					
			
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item
								label={langdata?.Status || 'Status'}
								name="status"
								rules={[{ required: false, message: 'Please select a status' }]}
							>
								<Select
									name="status"
									onChange={(value) => addAsset.setFieldValue('status', value)}
									placeholder={langdata?.SelectStatus || 'Select Status'}
								>
									<Option value={langdata?.InUse || 'In Use'}>{langdata?.InUse || 'In Use'}</Option>
									<Option value={langdata?.Maintenance || 'Maintenance'}>{langdata?.Maintenance || 'Maintenance'}</Option>
									<Option value={langdata?.Damaged || 'Damaged'}>{langdata?.Damaged || 'Damaged'}</Option>
								</Select>
							</Form.Item>
			
						</Col>
					</Row> 
					

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item
								label={langdata && langdata.Region ? langdata.Region : 'Region'}
								// name="regioninfoId"
								rules={[{ required: true }]}>

								<Select
									name="regioninfoId"
									style={{ minWidth: '100%'}}
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.Region ? langdata.Region : 'Region'}
									optionFilterProp="children"
									options={modalRegion}
									onChange={handleRegion}
									
									onSelect={(value)=>{handleAddFormValuesChange({'regioninfoId': value});}}

									
	
								/>

							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item
								label={langdata?.Chainage || 'Chainage'}
								// name="pipelineChainageId"
								rules={[{ required: true }]}>

								<Select
									name="pipelineChainageId"
									style={{ minWidth: '100%'}}
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.StartingChainage ? langdata.StartingChainage : 'Starting Chainage '}
									optionFilterProp="children"
									options={pipelineChainages}

									onChange={(value)=>handleStartChainage(value,'add')}
									// value={showChainage}
									value={addAsset.values.pipelineChainageId}
								/>

							</Form.Item>
						</Col>
					</Row>
					
					<Row
						gutter={24}
					>			
						<Col  span={24}>  
							
							<Form.Item
								label={langdata && langdata.Attachments ? langdata.Attachments : 'Attachments'}
								name="Image"
								rules={[{ required: false }]}>
								<Button >
											
									<input onChange={(value)=>{onChangeImage(value,'add');}} id='fileUpload' type='file' multiple  
										accept="image/*"
									/>
								</Button>
							</Form.Item>
						</Col>
					</Row>
								
																	
				</Form>
			</Modal>

			{/* Edit Asset Starts */}
			<Modal
				title={langdata && langdata.EditAssetDetails ? langdata.EditAssetDetails:'Edit Asset Details'}
				width={800}	
				centered
				destroyOnClose={true}
				maskClosable={false}
				onOk={formik.handleSubmit}
				onCancel={handleModalCancel}
				open={openEditDrawer}
				styles={{
					body: {
					},
				}}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleModalCancel}>
							{langdata && langdata.CANCEL ? langdata.CANCEL:'CANCEL'}
						</Button>
						<Button onClick={formik.handleSubmit} type="primary">
							{langdata && langdata.SAVE ? langdata.SAVE:'SAVE'}
						</Button>
					</Space>
				]}
			>
				<Form onSubmit={formik.handleSubmit} layout="vertical"
					form={form} 
					onValuesChange={handleUpdateFormValuesChange}
				>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.AssetName ? langdata.AssetName:'Asset Name'} rules={[{ required: false, message: `${langdata && langdata.Name ? langdata.Name:'Name'}` }]}>
								<Input name="name" value={formik.values.name} onChange={formik.handleChange} defaultValue={asset.details?.name}  placeholder={langdata && langdata.Name ? langdata.Name:'Name'} />
							</Form.Item>
						</Col>
					</Row>

					
  
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="remarks" label={langdata && langdata.Remarks ? langdata.Remarks:'Remarks'} rules={[{ required: false, message: `${langdata && langdata.Pleaseenteryourremarks ? langdata.Pleaseenteryourremarks:'Please enter your remarks'}` }]} >
								<Input name="remarks" value={formik.values.remarks} onChange={formik.handleChange} defaultValue={asset.details?.remarks} placeholder={langdata && langdata.Pleaseenteryourremarks ? langdata.Pleaseenteryourremarks:'Please enter your remarks'} />
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item
								label={langdata?.AssetType || 'Asset Type'}
								// name="assetType"
								rules={[{ required: false, message: 'Please select an asset type' }]}
							>
								<Select
									name="assetType"
									style={{ minWidth: '100%'}}
									defaultValue={formik.values.assettypeId}
									filterOption={filterOption}
									placeholder={langdata && langdata.AssetType ? langdata.AssetType : 'Asset Type'}
									optionFilterProp="children"
									options={modalAssetTypeOptions}
									onSelect={(value)=>{handleUpdateFormValuesChange({'assettypeId': value});}}
									
									

								/>
							

							</Form.Item>
			
						</Col>
					</Row> 

					
					
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item
								label={langdata?.Status || 'Status'}
								name="status"
								rules={[{ required: false, message: 'Please select a status' }]}
							>
								<Select
									defaultValue={formik.values.status}
									onChange={(value) => formik.setFieldValue('status', value)}
									placeholder={langdata?.SelectStatus || 'Select Status'}
								>
									<Option value={langdata?.InUse || 'In Use'}>{langdata?.InUse || 'In Use'}</Option>
									<Option value={langdata?.Maintenance || 'Maintenance'}>{langdata?.Maintenance || 'Maintenance'}</Option>
									<Option value={langdata?.Damaged || 'Damaged'}>{langdata?.Damaged || 'Damaged'}</Option>
								</Select>
							</Form.Item>

						</Col>
					</Row> 
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item
								label={langdata && langdata.Region ? langdata.Region : 'Region'}
								// name="regioninfoId"
								rules={[{ required: false }]}>

								<Select

									name="regioninfoId"
									// filterOption={filterOption}
									placeholder={langdata && langdata.Region ? langdata.Region : 'Region'}

									options={modalRegion}
									onSelect={(value)=>{handleUpdateFormValuesChange({'regioninfoId': value});}}
									defaultValue={formik.values.regioninfoId}
									onChange={handleRegion}
									


								/>

							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item
								label={langdata?.Chainage || 'Chainage'}
								
								rules={[{ required: false }]}
								id='pipelineChainageId'>

								<Select
									name="pipelineChainageId"
									style={{ minWidth: '100%'}}
									defaultValue={formik.values.pipelineChainageId}
									value={ formik.values.pipelineChainageId }
									placeholder={langdata && langdata.StartingChainage ? langdata.StartingChainage : 'Starting Chainage '}
									options={pipelineChainages}
									onChange={(value)=>{formik.setFieldValue('pipelineChainageId', value);}}
							
									
									
								/>

							</Form.Item>
						</Col>
					</Row>
					<Row
						gutter={24}
					>			
						<Col  span={24}>  
							
							<Form.Item
								label={langdata && langdata.Attachments ? langdata.Attachments : 'Attachments'}
								name="Image"
								rules={[{ required: false }]}>
								<Button >
											
									<input onChange={(value)=>{onChangeImage(value,'edit');}} id='fileUpload' type='file' multiple  
										accept="image/*"
									/>
								</Button>
							</Form.Item>
						</Col>
					</Row>



					
				</Form>
			</Modal>
			{/* Edit Asset ends */}


			


 
			{/* Attachment Modal starts */}
			<Modal
				title={langdata && langdata.Attachments ? langdata.Attachments:'Attachments'}
				centered
				destroyOnClose={true}
				open={openAttachmentModal}
				onOk={{closeShowAttachments}}
				onCancel={closeShowAttachments}
				footer={[
				]}
				width={540}>
				<div  style={{ paddingTop: '20px',height:'400px',overflowY:'scroll' }}>

					<>
						<Tabs defaultActiveKey='1' style={{marginBottom:'10px'}}>
							<TabPane tab='Image' key='1'  >

								{image_attachements && image_attachements.length>0 ?

									image_attachements.map((item,index)=>(

										<div key={index}>
											<img  style={{width:'100%', height:'360px'}} src={item.trim()} alt='image' />

											<a target="_blank" href={item.trim()} onClick={() => {
												handleDownload(item.trim());
											}} rel="noreferrer" >
												<br/> 
												<DownloadOutlined style={{fontSize:'20px',marginTop:'5px',marginBottom:'20px'}}/> {langdata && langdata.Downloadfile ? langdata.Downloadfile:'Download file'}</a>
																


										</div>
									)):
									<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
								}

							</TabPane>
																	
						</Tabs>
					</>
				</div>
			</Modal> 

			<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteAssetsModal} onOk={deleteAssets} onCancel={closeDeleteAssetsModal}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}> { langdata && langdata.AreYouSureYouWantToDeleteThisAsset ? langdata.AreYouSureYouWantToDeleteThisAsset : '' }</Col>
				</Row>
			</Modal>


			<Modal
				title={langdata && langdata.DownloadReport ? langdata.DownloadReport:'Download Report'}
				centered
				destroyOnClose={true}
				open={showFetchAndDownloadModal}
				onOk={{closeShowFetchAndDownloadModal}}
				onCancel={closeShowFetchAndDownloadModal}
				footer={[
								
				]}
				width={540}
			>
				<Row gutter={16}>
					<Col span={24}>
						<Typography>
							{langdata && langdata.Totalnumberofrecords ? langdata.Totalnumberofrecords:'Total number of records'} : {asset_data_pagination.total}
						</Typography>
					</Col>
				</Row>
			
				{asset_data_pagination && asset_data_pagination.total> 0 ? (
					<BatchDownloader total={asset_data_pagination && asset_data_pagination.total} url={url}/>
				) : (
					<>
						<Row gutter={16} style={{
							backgroundColor: '#d3d3d3',
							padding: '5px',
							marginTop: '10px'
						}}>
							<Col span={24}>
								<Typography>{langdata && langdata.Norecordsfound ? langdata.Norecordsfound:'No records found.'}</Typography>
							</Col>
						</Row>
						<br/>
					</>
				)}
			</Modal>


			
			
		</>
	);
}